import { useEffect } from 'react';
import { useStyletron } from '@tigergraph/app-ui-lib/Theme';
import { Block } from 'baseui/block';
import { useQueryParams } from '@/components/landing/hooks.ts';
import { HeadingLarge } from 'baseui/typography';
import { Body2 } from '@tigergraph/app-ui-lib/typography';
import emailLogo from '@/assets/email-logo.png';
import { trackEmailVerificationPageViewed } from '@/hooks/usePageViewed';
import trackUtil from '@/utils/analytics-service';

export function EmailSend() {
  const [css] = useStyletron();
  const queryParams = useQueryParams();

  const verifiedEmail = (queryParams && decodeURI(queryParams.get('email') || '')) || '';
  const email = verifiedEmail || 'email';

  useEffect(() => {
    // This is the one pre-authentication page that knows who the user is. Hand the address
    // over first so the production internal-user filter can apply to the event below.
    trackUtil.identifyPreAuthUser(verifiedEmail);
    trackEmailVerificationPageViewed();
  }, [verifiedEmail]);

  return (
    <div
      className={css({
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <Block display="flex" flexDirection="column" alignItems="center">
        <HeadingLarge as="div">Great! Now verify your email</HeadingLarge>
        <Block marginTop="72px">
          <img alt="" src={emailLogo} />
        </Block>
        <Body2 marginTop="32px">
          Please check your{' '}
          <Body2 as="span" $style={{ fontWeight: 600 }}>
            {email}
          </Body2>{' '}
          inbox to verify your email, and log in to your account from there.
        </Body2>
      </Block>
    </div>
  );
}
